<template>
  <div class="wrapper d-flex flex-column min-vh-100">
    <div class="body flex-grow-1">
      <div class="container">
        <router-view/>
      </div>
    </div>
  </div>
</template>

